import { APICore } from "./apiCore";

const api = new APICore();

// course
function addMainBanner(params: {
  file: any;
  head: string;
  subhead: string;
  head_ar: string;
  subhead_ar: string;
  title_text: string;
  title_text_ar: string;
}) {
  

  const baseUrl = "/main_banner";
  return api.createWithFile(`${baseUrl}`, params);
}

function getMainBannerApi() {
  const baseUrl = "/main_banner";
  return api.get(`${baseUrl}`, {});
}

function updateMainBanner(
  id: number,
  params: {
    title_text: string;
    title_text_ar: string;
    file: any;
    head: string;
    subhead: string;
    head_ar: string;
    subhead_ar: string;
  }
) {
  const baseUrl = `/main_banner/${id}`;
  return api.updateWithFile(`${baseUrl}`, params);
}

function deleteMainBanner(id: number) {
  const baseUrl = `/main_banner/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addMainBanner, deleteMainBanner, getMainBannerApi, updateMainBanner };
